// src/components/BuddyToolCard.js
import React from 'react';
import './BuddyToolCard.css';

// Star Icon
const StarIcon = ({ isFavorite }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill={isFavorite ? 'gold' : 'none'}
    stroke={isFavorite ? 'gold' : 'currentColor'}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
  </svg>
);

const BuddyToolCard = ({ tool, viewMode, isFavorite, onFavoriteToggle, isPublicPage = false }) => {
  const { title, image, description } = tool;

  const handleFavoriteClick = (e) => {
    e.stopPropagation(); // Prevent card click event
    onFavoriteToggle(tool.id);
  };

  const cardClasses = `
    buddy-tool-card
    ${viewMode}
    ${isFavorite ? 'favorite' : ''}
    ${isPublicPage ? 'public-card' : ''}
  `;

  const tooltipHtml = viewMode === 'grid'
    ? `<strong>${title}</strong><br/>${description}`
    : description;

  return (
    <div
      className={cardClasses.trim()}
      data-tooltip-id="buddy-tooltip"
      data-tooltip-html={tooltipHtml}
    >
      {!isPublicPage && (
        <button
          className="favorite-btn"
          onClick={handleFavoriteClick}
          aria-label={isFavorite ? `Unfavorite ${title}` : `Favorite ${title}`}
        >
          <StarIcon isFavorite={isFavorite} />
        </button>
      )}
      {image && (
        <img
          src={image}
          alt={`${title} icon`}
          className={`card-image ${image.toString().includes('.svg') ? 'svg-image' : ''}`}
        />
      )}
      <div className="card-content">
        <h3 className="card-title">{title}</h3>
        {viewMode === 'list' && <p className="card-description">{description}</p>}
      </div>
    </div>
  );
};

export default BuddyToolCard;
